export default __webpack_public_path__ + "static/media/coach_guide_lancingkit_lancets100_strips250_white@3x.3b17949d.webp";